import React from 'react'
import { observable, action } from 'mobx'
import { CommonContainer } from '../Common'
import { getLocaleCodeFromUrl } from 'src/utils'

class MysiteContainer extends CommonContainer {
  @observable mysiteShopHeaderResponse = null
  @observable nextgenMysiteResponse = null
  @observable mysiteSponsor = null
  @observable mysiteDomain = null
  @observable isMysiteMemberPrice = undefined
  @observable mySiteBreadCrumbList = []
  @observable mysiteSponsorFromCustomer = null
  @observable mysitePriceType = null
  @observable mysiteSkipNavigation = {
    showBannner: false,
    customCategory: false,
  }
  @observable mysiteDefaultCategoryInfo = {
    categoryName: '',
    categoryDescription: '',
    siteDescription: '',
  }
  @observable mysiteDefaultCategoriesFromCS = []
  @observable mysiteApiError = null
  @observable invalidMysiteDomain = false
  @observable selectedCategoryId = ''

  constructor() {
    super()
  }

  @action
  setMysiteShopHeaderResponse = response => {
    this.mysiteShopHeaderResponse = response
    this.updateMysiteMandateData()
  }

  @action
  updateMysiteMandateData = () => {
    if (this.mysiteShopHeaderResponse) {
      const locale = getLocaleCodeFromUrl() || null
      const lang = locale?.split('_')[0] || 'en'
      const market = this.mysiteShopHeaderResponse?.market || {}
      const mySitePriceType = market?.lang?.[lang]?.priceType || ''
      this.mysitePriceType = mySitePriceType?.toLowerCase() || ''
      this.mysiteSkipNavigation = {
        showBannner: market?.banner?.showBanner,
        customCategory: market?.showCustomCategory,
      }
    }
  }

  @action
  setMysiteDefaultCategoryInfo = info => {
    this.mysiteDefaultCategoryInfo = info
  }

  @action
  setMysiteDefaultCategoriesFromCS = categories => {
    this.mysiteDefaultCategoriesFromCS = Array.isArray(categories)
      ? categories
      : []
  }

  @action
  setMysiteApiError = errorMessage => {
    this.mysiteApiError = errorMessage
  }

  @action
  clearMysiteApiError = () => {
    this.mysiteApiError = null
  }
}

const mysiteContainer = new MysiteContainer()
export { mysiteContainer, MysiteContainer }
export default mysiteContainer
